// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Конструктор законопроєктів» (Legislation Designer, ключ `lds`, група `legislation`). */
export const legislationDesignerManifest: IModuleManifest = {
  key: 'lds',
  group: 'legislation',
  slug: 'legislation-designer',
  prefix: 'LDS',
  name: { en: 'Legislation Designer', uk: 'Конструктор законопроєктів' },
  entities: [
    { key: 'lds', slug: 'lds', name: { en: 'List of bills', uk: 'Перелік законопроєктів' }, main: true },
    { key: 'lprob', slug: 'lprob', name: { en: 'Legal problems', uk: 'Правові проблеми' }, main: false },
    { key: 'lrisk', slug: 'lrisk', name: { en: 'Legal risks', uk: 'Правові ризики' }, main: false },
    { key: 'lopp', slug: 'lopp', name: { en: 'Legal opportunities', uk: 'Правові можливості' }, main: false },
    { key: 'lhyp', slug: 'lhyp', name: { en: 'Legal hypotheses', uk: 'Правові гіпотези' }, main: false },
    { key: 'lissue', slug: 'lissue', name: { en: 'Legal issues', uk: 'Правові питання' }, main: false },
    { key: 'ldedit', slug: 'ldedit', name: { en: 'Edits', uk: 'Правки' }, main: false },
    { key: 'ldcom', slug: 'ldcom', name: { en: 'Comments on text', uk: 'Коментарі до тексту' }, main: false },
    { key: 'ldver', slug: 'ldver', name: { en: 'Versions', uk: 'Версії' }, main: false },
    { key: 'ldprob', slug: 'ldprob', name: { en: 'Problems solved', uk: 'Проблеми, які розв’язує' }, main: false },
    { key: 'ldorg', slug: 'ldorg', name: { en: 'Regulated structures', uk: 'Структури, які регулює' }, main: false },
    { key: 'ldstake', slug: 'ldstake', name: { en: 'Stakeholders and interests', uk: 'Зацікавлені сторони та інтереси' }, main: false },
    { key: 'ldart', slug: 'ldart', name: { en: 'Articles', uk: 'Статті' }, main: false },
    { key: 'ldimp', slug: 'ldimp', name: { en: 'Impacts', uk: 'Впливи' }, main: false },
    { key: 'ldconf', slug: 'ldconf', name: { en: 'Legal conflicts', uk: 'Колізії' }, main: false },
    { key: 'ldlink', slug: 'ldlink', name: { en: 'Linked acts', uk: 'Пов’язані акти' }, main: false },
    { key: 'draft_article', slug: 'draft-article', name: { en: 'Draft Articles', uk: 'Статті' }, main: false },
    { key: 'draft_reference', slug: 'draft-reference', name: { en: 'Draft References', uk: 'Посилання' }, main: false },
    { key: 'draft_version', slug: 'draft-version', name: { en: 'Draft Versions', uk: 'Версії' }, main: false },
  ],
  loadState: () => import('./state/legislationDesignerSlice').then((m) => m.legislationDesignerSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
